import React from 'react';
import { Layout } from './components/Layout';
import { Hero, Problem, Catalog, Benefits, Guarantee, Testimonials, FinalCTA } from './components/Sections';
export function App() {
  return <Layout data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Catalog data-id="element-3" />
      <Benefits data-id="element-4" />
      <Guarantee data-id="element-5" />
      <Testimonials data-id="element-6" />
      <FinalCTA data-id="element-7" />
    </Layout>;
}